export const DOTDIGITAL_CUSTOM_FIELD_MAPPINGS = [
  {
    source: "organisation",
    label: "Organisation",
    defaultDotdigitalField: "ORGANISATION",
  },
];

export function buildDefaultDotdigitalFieldMappings() {
  return Object.fromEntries(
    DOTDIGITAL_CUSTOM_FIELD_MAPPINGS.map((field) => [field.source, field.defaultDotdigitalField])
  );
}

export function normalizeDotdigitalFieldMappings(value) {
  return {
    ...buildDefaultDotdigitalFieldMappings(),
    ...(value && typeof value === "object" ? value : {}),
  };
}
